/* eslint-disable arrow-body-style */
/* eslint-disable padding-line-between-statements */
import { useModal } from '@jutro/components';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { getApdLobQuoteUrl, getApdLobs } from '@xengage/gw-portals-url-js';
import { JobUtil, LocalDateUtil } from '@xengage/gw-portals-util-js';
import { useValidation } from '@xengage/gw-portals-validation-react';
import {
    ViewModelForm,
    ViewModelServiceContext,
} from '@xengage/gw-portals-viewmodel-react';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { OrganizationService, SubmissionService } from 'gw-capability-gateway';
import { AccountService } from 'gw-capability-gateway-policy';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import gatewayMessages from '../../../gateway.messages';
import messages from '../../NewQuoteAccountSearch.messages';
import metadata from './NewSubmissionPage.metadata.json5';
import styles from './NewSubmissionPage.module.scss';
import { TranslatorContext } from '@jutro/locale';

function NewSubmissionPage(props) {
    const { showAlert, showConfirm } = useModal();

    const viewModelService = useContext(ViewModelServiceContext);
    const {
        isAnExistingAccount,
        submissionVM,
        postalCode,
        updateSubmissionVM,
        producerCodeValue,
        isAgent,
        allOrganisationValue,
        authHeader,
        maxDateConstant,
        isTWIA,
        selectedProducerCode
    } = props;
    const [productValue, updateProductValue] = useState([]);
    const [producerCodeOrgValue, updateProducerCodeValue] = useState([]);
    const [selectedOrganisationValue, updateOrganisation] = useState('');
    const [showErrors, updateShowErrors] = useState([false]);
    const [dateFormat, setDateFormat] = useState([]);
    const [maxminDate, setMaxMinDate] = useState([]);
    const { history } = props;
    const { lobQuoteURL } = appConfig;
    const { onValidate, isComponentValid } = useValidation('NewSubmissionPage');
    const translator = useContext(TranslatorContext)

    const startSubmission = useCallback(async () => {
        const productCode = _.get(submissionVM, 'productCode.value');

        if (!_.isNil(getApdLobQuoteUrl(productCode))) {
            const accountId = _.get(submissionVM, 'accountPublicId');
            const nextLocation = {
                productCode,
                accountId,
                jobId: undefined,
            };
            history.push(getApdLobQuoteUrl(productCode), nextLocation);
        } else {
            try { 
                const newSubmissionResponse =
                await SubmissionService.createSubmission(
                    submissionVM.value,
                    authHeader
                );
                if (newSubmissionResponse.jobNumber > 0) {
                    // US26481 switch the residential wizard by company
                    const isTFPA = newSubmissionResponse.underwritingCompany_TWIA === '1001_00001';
                    const isHomeowners = productCode == 'Homeowners';
                    const quoteURL = isTFPA && isHomeowners ? lobQuoteURL['HomeownersTFPA'] : lobQuoteURL[productCode];
                    if (!_.isNil(quoteURL)) {
                        const nextLocation = {
                            quoteentry: {
                                postalCode: postalCode,
                                quoteID: newSubmissionResponse.jobNumber,
                            },
                            productCode,
                        };
                        history.push(quoteURL, nextLocation);
                    } else {
                        JobUtil.openJobInXCenter(newSubmissionResponse.jobNumber);
                    }
                }
            } catch (e) { // US26332 - Common Quote - Deactivated Producer Code
                if (e.appErrorCode === 11001) {
                    return showAlert({
                            title: gatewayMessages.modalError,
                            message: messages.errorDescription,
                            status: 'error',
                            icon: 'mi-error-outline',
                            confirmButtonText: commonMessages.cancelModel,
                        }).catch(_.noop);
                }
            }
        }
    }, [submissionVM, history, authHeader, lobQuoteURL, postalCode, showAlert]);

    const inferProductName = productCode => {
        const productName = productCode.replace(/([A-Z])/g, ' $1');
        return productName.charAt(0).toUpperCase() + productName.slice(1);
    };

    const refreshProducts = useCallback(
        async newSubmissionVM => {
            if(!newSubmissionVM.effectiveDate.aspects.valid){
                return
            }
            try {
                const submission = {
                    ...newSubmissionVM.value,
                    // product code is a required field and must have a value
                    productCode: _.get(
                        newSubmissionVM,
                        'productCode.value',
                        ''
                    ),
                };
                const productCodeResponse =
                    await AccountService.getAvailableProductsForAccount(
                        submission,
                        authHeader
                    );
                const productCodeValues = productCodeResponse;
                const productCodeAvailableValue = productCodeValues
                    .filter(value => !value.isRiskReserved)
                    .map(({ productCode, productName }) => {
                        return {
                            code: productCode,
                            name: productName,
                        };
                    });
                const apdLobs = getApdLobs().map(productCode => {
                    return {
                        code: productCode,
                        name: inferProductName(productCode),
                    };
                });
                apdLobs.forEach(apdLob => {
                    const element = productCodeAvailableValue.find(
                        lob => lob.code === apdLob.code
                    );
                    if (element === undefined) {
                        productCodeAvailableValue.push(apdLob);
                    }
                });

                updateProductValue(productCodeAvailableValue);
            } catch {
                updateProductValue([]);
                showAlert({
                    title: gatewayMessages.modalError,
                    message: gatewayMessages.gatewayViewsModalErrorData,
                    status: 'error',
                    icon: 'mi-error-outline',
                }).catch(_.noop);
            }
        },
        [authHeader, showAlert]
    );

    const getProducerCodesOrganization = useCallback(
        async organisationCode => {
            const producerCodeResponse =
                await OrganizationService.getProducerCodeForOrganization(
                    organisationCode,
                    authHeader
                );
            const producerCodeOrganisation = producerCodeResponse.map(value => {
                return {
                    code: value.code,
                    name: value.displayValue,
                };
            });
            updateProducerCodeValue(producerCodeOrganisation);
            _.set(submissionVM, 'producerCode', '');
            _.set(submissionVM, 'productCode', '');
            updateSubmissionVM(submissionVM);
        },
        [authHeader, submissionVM, updateSubmissionVM]
    );
    const handleValueOrganisation = value => {
        let organisationCode = {};

        const selectedOrganisation = value;
        allOrganisationValue.forEach(result => {
            if (result.code === selectedOrganisation) {
                organisationCode = {
                    displayName: result.name,
                    publicID: result.code,
                };
            }
        });
        getProducerCodesOrganization(organisationCode);
        updateOrganisation(value);
    };

    useEffect(() => {
        if(isAgent) {
            if(producerCodeValue?.length > 0) { // DE17827
                writeValue(selectedProducerCode[0].code, 'producerCode')
            }
        }  
    }, [producerCodeValue])

    useEffect(() => {
        if(productValue?.length == 1) {
            writeValue(productValue[0].code, 'productCode')
        }  
    }, [productValue])

    const writeValue = useCallback(
        (value, path) => {
            const accountId = _.get(submissionVM, 'accountPublicId');
            const newSubmissionVMClone = viewModelService.clone(submissionVM);
            _.set(newSubmissionVMClone.value, path, value);
            _.set(newSubmissionVMClone.value, 'accountPublicId', accountId);
            updateSubmissionVM(newSubmissionVMClone);

             //DE15849
            setDateFormat([]);
            setMaxMinDate([]);
            const dateEntered = submissionVM.effectiveDate.value;
            if (_.isUndefined(dateEntered)) {
                setDateFormat(translator(messages.dateMustmatch));
            } else {checkDateLimit(dateEntered);}

            if ((path === 'producerCode' ||
                    path === 'effectiveDate' ||
                    path === 'state') &&
                !!(
                    _.get(newSubmissionVMClone, 'producerCode.value') &&
                    _.get(newSubmissionVMClone, 'state.value.code') &&
                    _.get(newSubmissionVMClone, 'effectiveDate.value')
                )
            ) {
                refreshProducts(newSubmissionVMClone);
                _.set(newSubmissionVMClone.value, 'productCode', '');
                _.set(newSubmissionVMClone.value, 'accountPublicId', accountId);
                updateSubmissionVM(newSubmissionVMClone);
            }
        },
        [refreshProducts, submissionVM, updateSubmissionVM, viewModelService]
    );
    const handleCancel = useCallback(() => {
        const accountNumber = _.get(submissionVM, 'accountNumber.value');
        showConfirm({
            title: messages.cancelQuote,
            message: messages.cancelMessageSubmission,
            status: 'warning',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.yes,
            cancelButtonText: commonMessages.noModel,
        }).then(results => {
            if (results === 'cancel' || results === 'close') {
                return _.noop();
            }
            if (accountNumber) {
                history.push(`/accounts/${accountNumber}/summary`);
            } else {
                history.push('/');
            }
            return true;
        }, _.noop);
    }, [history, showConfirm, submissionVM]);

    //DE15849 fix
    const checkDateLimit = useCallback((dateEntered) => {
        const { day, month, year } = dateEntered;
        const dateToValidate = new Date(year, month, day);
        const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const maxDateAllowed = new Date(today);
        maxDateAllowed.setDate(today.getDate() + maxDateConstant);
        setMaxMinDate([]);
 
        if (dateToValidate < today || dateToValidate > maxDateAllowed) {
            const formattedMessage = translator(messages.validationMessage, { maxDateConstant });
            setMaxMinDate(formattedMessage);
        }
    }, [maxDateConstant, translator]);
    

    //DE15849
    const checkValidDate = useCallback(() => {
        let validationMessages = [];

        if (!_.isEmpty(dateFormat)) {
            validationMessages.push(dateFormat);
        }
    
        if (!_.isEmpty(maxminDate)) {
            validationMessages.push(maxminDate);
        }

        return validationMessages;
    }, [dateFormat, maxminDate]);

    const handleValidation = useCallback(() => {
        updateShowErrors(true);
    }, [updateShowErrors]);
    const producerdisable =
        producerCodeOrgValue.length > 0
            ? isAgent
            : producerCodeOrgValue.length === 0;
    const isAgentProducer = !isAgent ? producerdisable : (!isAnExistingAccount || _.get(submissionVM, 'producerCode.value'));
    const overrideProps = {
        '@field': {
            labelPosition: 'left',
            showRequired: true
        },
        submissionProducerCode: {
            availableValues:
                _.isArray(producerCodeValue) && producerCodeValue.length > 0
                    ? producerCodeValue
                    : producerCodeOrgValue,
            disabled: isAgentProducer,
            label: isAgent ? translator(messages.producerCodeName) : translator(messages.producerCode)
        },
        submissionState: {
            disabled: true,
        },
        submissionDate: {
            label: translator(messages.requestedCoverageStartDate),// DE15807 use the same label for TWIA and TFPA
            validationMessages: checkValidDate(), //DE15849
        },
        submissionProductCode: {
            availableValues: productValue,
            disabled: !_.get(submissionVM, 'producerCode.value'),
        },
        submissionOrganisation: {
            visible: !isAgent,
            availableValues: allOrganisationValue,
            onValueChange: handleValueOrganisation,
            value: selectedOrganisationValue,
        },
        cancel: {
            disabled: !isAnExistingAccount,
        },
        next: {
            disabled: !isAnExistingAccount,
        },
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            startSubmission: isComponentValid
                ? startSubmission
                : handleValidation,
            onCancel: handleCancel,
        },
    };
    const readValue = (id, path) => {
        return readViewModelValue(
            metadata.pageContent,
            submissionVM,
            id,
            path,
            overrideProps
        );
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={submissionVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValidationChange={onValidate}
            onValueChange={writeValue}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
            showErrors={showErrors}
        />
    );
}
NewSubmissionPage.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,
    isAnExistingAccount: PropTypes.bool,
    submissionVM: PropTypes.shape({
        value: PropTypes.shape({}),
    }),
    allOrganisationValue: PropTypes.shape({}),
    postalCode: PropTypes.string,
    updateSubmissionVM: PropTypes.func,
    producerCodeValue: PropTypes.arrayOf(PropTypes.string),
    isAgent: PropTypes.bool,
    authHeader: PropTypes.shape({}),
};

NewSubmissionPage.defaultProps = {
    isAnExistingAccount: false,
    submissionVM: {},
    allOrganisationValue: [],
    postalCode: '',
    updateSubmissionVM: undefined,
    producerCodeValue: [],
    isAgent: false,
    authHeader: {},
};
export default withRouter(NewSubmissionPage);
